export const variables = {
  fontBasic: '10px',
  fontFamily: 'Rubik',
  fontSize: '2.4rem',
  lineHeight: '1.4em',
  fontRegular: 400,
  fontBold: 600,
}
